var _style, _desc, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0488DB;}\n\t.st1{fill:#046DB5;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F0F0F0;}\n\t.st4{display:none;fill:#0263A6;}\n\t.st5{display:none;fill:#03558E;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,2C81.2,2,43.3,39.9,43.3,86.6c0,61.7,61,105.7,81,164.8c0.6,1.8,2.1,2.6,3.6,2.6 C143.3,163.4,146.2,78.2,128,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,2c46.8,0,84.7,37.9,84.7,84.6c0,61.7-61,105.7-81,164.8c-0.6,1.8-2.1,2.6-3.6,2.6V2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128,22.5c-34.8,0-63,28.2-63,63s28.2,63,63,63C144.8,106.5,144.8,64.5,128,22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128,22.5c34.8,0,63,28.2,63,63s-28.2,63-63,63V22.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.3,30.7 34.7,30.7 34.7,18.4 30.7,18.4 30.7,30.7 30.7,35.3 30.7,41.2 34.7,41.2 34.7,35.3 55.3,35.3  55.3,41.2 59.3,41.2 59.3,35.3 59.3,30.7  "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.8,
    cy: 26.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,28.9H44.2v-4.2c0-0.8,0.6-1.4,1.4-1.4h8.1C56.8,23.3,59.3,25.8,59.3,28.9L59.3,28.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelPin);
export default __webpack_public_path__ + "static/media/hotel_pin.2c9d4e8a0202cc4b4772f0bcea6a37fa.svg";
export { ForwardRef as ReactComponent };